export const INTERVAL_UNITS = ['minutes', 'hours', 'day'] as const;

export type IntervalUnit = (typeof INTERVAL_UNITS)[number];

export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = 1440;

export function isRetryIntervalAtLeast(
  value: number,
  unit: IntervalUnit,
  minMinutes: number,
): boolean {
  return toRetryIntervalMinutes(value, unit) >= minMinutes;
}

export function toRetryIntervalMinutes(value: number, unit: IntervalUnit): number {
  if (unit === 'hours') {
    return value * MINUTES_PER_HOUR;
  }
  if (unit === 'day') {
    return value * MINUTES_PER_DAY;
  }
  return value;
}

/** Largest even unit: day if divisible by 1440, else hours if divisible by 60, else minutes. */
export function fromRetryIntervalMinutes(minutes: number): { value: number; unit: IntervalUnit } {
  if (minutes > 0 && minutes % MINUTES_PER_DAY === 0) {
    return { value: minutes / MINUTES_PER_DAY, unit: 'day' };
  }
  if (minutes > 0 && minutes % MINUTES_PER_HOUR === 0) {
    return { value: minutes / MINUTES_PER_HOUR, unit: 'hours' };
  }
  return { value: minutes, unit: 'minutes' };
}

/** Picker phrase for `{interval}` at send time. */
export function retryIntervalPhrase(minutes: number): string {
  const { value, unit } = fromRetryIntervalMinutes(minutes);
  if (unit === 'day') {
    return value === 1 ? '1 day' : `${value} days`;
  }
  if (unit === 'hours') {
    return value === 1 ? '1 hour' : `${value} hours`;
  }
  return value === 1 ? '1 minute' : `${value} minutes`;
}
